module.exports = __webpack_public_path__ + "img/alice margatroid_lw.6f23c637.png";